"use strict";
// (C) 2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.canSortStackTotalValue = void 0;
var sdk_ui_1 = require("@gooddata/sdk-ui");
var bucketHelper_1 = require("../../../utils/bucketHelper");
function areAllMeasuresOnSingleAxis(buckets, secondaryAxis) {
    var _a, _b;
    var measures = bucketHelper_1.getBucketItems(buckets, sdk_ui_1.BucketNames.MEASURES);
    var measureCount = measures.length;
    var numberOfMeasureOnSecondaryAxis = (_b = (_a = secondaryAxis.measures) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
    return numberOfMeasureOnSecondaryAxis === 0 || measureCount === numberOfMeasureOnSecondaryAxis;
}
function canSortStackTotalValue(buckets, properties) {
    var _a, _b;
    var supportedControls = properties === null || properties === void 0 ? void 0 : properties.controls;
    var stackMeasures = (_a = supportedControls === null || supportedControls === void 0 ? void 0 : supportedControls.stackMeasures) !== null && _a !== void 0 ? _a : false;
    var secondaryAxis = (_b = supportedControls === null || supportedControls === void 0 ? void 0 : supportedControls.secondary_xaxis) !== null && _b !== void 0 ? _b : { measures: [] };
    var allMeasuresOnSingleAxis = areAllMeasuresOnSingleAxis(buckets, secondaryAxis);
    return stackMeasures && allMeasuresOnSingleAxis;
}
exports.canSortStackTotalValue = canSortStackTotalValue;
//# sourceMappingURL=sortHelpers.js.map